export default __webpack_public_path__ + "static/media/photo6.759b7af5.jpg";